import React, { Fragment, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { flagsGameCompleted, patchGameFlags } from "../../actions/game.action";
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";

import { checkGuessAlpha2Code, getFlagMode } from "../../utils";
import FlagLabel from "../gadgets/FlagLabel";
import FlagWave from "../gadgets/FlagWave";

const FlagsPage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { flags, countryOfToday } = useSelector(({ game }) => game);

  const handleGuess = (newGuess) => {
    const isCorrect = checkGuessAlpha2Code(newGuess, countryOfToday);
    if (isCorrect) {
      dispatch(flagsGameCompleted());
      toast.success(t("Congratulations!"));
    }
    if (flags.guesses.length < 9) {
      dispatch(
        patchGameFlags({
          guesses: [...new Set([...flags.guesses, newGuess])],
        }),
      );
    }
  };

  const flagsMap = useMemo(
    () =>
      countryOfToday?.flags?.map((flag) => ({
        ...flag,
        mode: getFlagMode(
          flag,
          flags?.guesses,
          countryOfToday,
          flags.completed,
        ),
      })) || [],
    [flags, countryOfToday],
  );

  return (
    <Fragment>
      <span
        className={`relative mt-6 w-full text-center font-bold text-slate-800 dark:text-slate-100 `}
      >
        {t("Do you know the flag for", { country: countryOfToday?.name })}
      </span>
      <div className={`my-4 grid w-full grid-cols-3 gap-2`}>
        {flagsMap?.map((flag, idx) => (
          <motion.div
            key={`svg-map-${idx}`}
            initial={{ opacity: 0, translateX: -20, translateY: -20 }}
            animate={{ opacity: 1, translateX: 0, translateY: 0 }}
            transition={{ delay: idx * 0.1 }}
            className={`transition-color relative cursor-pointer overflow-hidden rounded-xl ${
              [
                "border-2 border-solid border-majky-500 bg-majky-500 bg-opacity-50 ",
                "border-2 border-solid border-red-500 bg-red-500 bg-opacity-50 ",
                "border-2 border-solid border-blue-500 bg-blue-500 bg-opacity-50 ",
              ][flag.mode]
            } ${flag.mode === -1 && " bg-slate-200 "}  flex select-none flex-col items-center justify-center `}
            onClick={() => {
              if (!flags.completed && flag.mode === -1) handleGuess(flag);
            }}
          >
            <FlagWave
              className={"w-[90%]"}
              imageUrl={`/data/${flag.Alpha2Code?.toLowerCase()}/flag.svg`}
            />
            <FlagLabel label={flag.name} mode={flag.mode} />
          </motion.div>
        ))}
      </div>
    </Fragment>
  );
};

export default FlagsPage;
